var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SaveCategory',{attrs:{"categoryDetail":_vm.categoryDetail,"update":false},on:{"saveDetail":_vm.saveCategory,"cancelCreate":_vm.cancelCreate}})
}
var staticRenderFns = []

export { render, staticRenderFns }